import { render, staticRenderFns } from "./LesMicroNutriments.vue?vue&type=template&id=81b6697e&scoped=true"
import script from "./LesMicroNutriments.vue?vue&type=script&lang=js"
export * from "./LesMicroNutriments.vue?vue&type=script&lang=js"
import style0 from "./LesMicroNutriments.vue?vue&type=style&index=0&id=81b6697e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b6697e",
  null
  
)

export default component.exports